import { Card, Row, Col, Select, Spin } from 'antd'
import React, { useEffect, useState } from 'react'
import { DownOutlined, UserOutlined } from '@ant-design/icons';
import './Audittrail.css'
// import type { MenuProps } from 'antd';
import { Button, Dropdown, message, Space, Tooltip, DatePicker } from 'antd';
import AuditTrailTable from './AuditTrailTable';
import { useDispatch, useSelector } from 'react-redux';
import HeaderSelects from '../../Header/HeaderSelects';
import moment from 'moment';
import { onChangeHandler } from '../../../API-Interaction/apiServices/plants.api';
import { antIcon, disabledDate, formatDate } from '../../../Helpers/helpers';
import { generateReport } from '../../../API-Interaction/apiServices/auditTrails.api';
import { CSVLink } from "react-csv"
import { reasons } from '../../../Utils/constants';

const AuditTrail = () => {

  const { lists, current } = useSelector(state => state.plant)
  const dispatch = useDispatch()
  let { RangePicker } = DatePicker;
  const { pageLoaders, componentLoaders: { chart = false } } = useSelector(state => state?.utils.loaders)
  const [dropDownLists, setDropDownLists] = useState({
    plants: lists?.plants,
    halls: lists?.halls,
    lines: lists?.lines,
    shifts: current?.line?.shifts,
  })
  const [selectedId, setSelectedId] = useState({
    plant: current?.plant?._id,
    hall: 'All Halls',
    line: 'All',
    shift: current?.line?.shifts[0]?.name,
    date: moment(new Date()).format('DD-MM-YYYY'),
  })

  useEffect(() => {
    setDropDownLists(prev => ({
      plants: lists?.plants,
      halls: lists?.halls,
      lines: lists?.lines,
      shifts: current?.line?.shifts,
      reasons: reasons
    }))
    setSelectedId(prev => ({
      plant: current?.plant?._id,
      hall: 'All Halls',
      line: 'All',
      shift: current?.line?.shifts?.length && 'All Shifts',
      date: moment(new Date()).format('DD-MM-YYYY'),
      reason: 1,
    }))
  }, [current])

  const [logs, setLogs] = useState([])
  // console.log({ dropDownLists, selectedId })
  let handlers = {
    setters: {
      list: setDropDownLists,
      current: setSelectedId,
      setLogs: setLogs
    },
    getters: {
      list: dropDownLists,
      current: selectedId
    }
  }

  const printReport = () => {
    var divToPrint = document.getElementById("log-table");
    let newWin = window.open("");
    newWin.document.write(divToPrint.outerHTML);
    newWin.print();
    newWin.close();
  }

  return (
    <Spin indicator={antIcon} spinning={pageLoaders?.auditTrails || false}>
      <div className='layout'>
        <Col className='aligncard' md={24} >
          <h1 className='f-bold'>Audit Trails</h1>
        </Col>
        {/* </Row> */}
        <Card className='aligncard cardborder m-b' style={{ width: '100%' }}>
          <h1 className='f-bold1'>Extract Logs</h1>

          <Row>
            <Col lg={6} md={12} sm={24} >
              <Row>Plant</Row>
              <HeaderSelects
                selectData={{
                  options: dropDownLists?.plants || [],
                  value: selectedId?.plant,
                  onChange: (props) => onChangeHandler(props, 'plant', handlers, dispatch),
                  valueLabel: 'plantName', idLabel: '_id'
                }} />
            </Col>
            <Col lg={6} md={12} sm={24} >
              <Row>Hall</Row>
              <HeaderSelects
                selectData={{
                  options: [...dropDownLists?.halls, { index: 'All', hallName: 'All Halls' }] || [],
                  value: selectedId?.hall,
                  onChange: (props) => onChangeHandler(props, 'hall', handlers, dispatch),
                  valueLabel: 'hallName', idLabel: 'index'
                }} />
            </Col>
            <Col lg={6} md={12} sm={24} >
              <Row>Line</Row>
              <HeaderSelects
                selectData={{
                  options: [...dropDownLists?.lines, { id: 'All', lineName: 'All Lines' }] || [],
                  value: selectedId?.line,
                  onChange: (props) => onChangeHandler(props, 'line', handlers, dispatch),
                  valueLabel: 'lineName', idLabel: 'id'
                }} />
            </Col>
            <Col style={{ paddingRight: '10px' }} lg={6} md={12} sm={24} >
              <Row>Date</Row>
              <RangePicker
                onChange={(value, date) => setSelectedId(prev => ({ ...prev, start: value[0], end: value[1] }))}
                className='btn-width1'
                style={{ width: "fit-content" }}
                // format="YYYY-MM-DD"
                format="DD-MM-YYYY"
                defaultValue={[selectedId?.start, selectedId?.end] || [moment(new Date()), moment(new Date())]}
                value={[moment(selectedId?.start), moment(selectedId?.end)] || [moment(new Date()), moment(new Date())]}
                allowClear={false}
                showTime={{ format: 'hh:mm:ss' }}
                disabledDate={disabledDate}
              />
            </Col>
            <Col lg={6} md={12} sm={24} >
              <Row>Shift</Row>
              <HeaderSelects
                selectData={{
                  options: dropDownLists?.shifts?.length ? [...dropDownLists?.shifts, { name: 'All Shifts' }] : [],
                  value: selectedId?.shift,
                  onChange: (props) => onChangeHandler(props, 'shift', handlers, dispatch),
                  valueLabel: 'name', idLabel: 'name'
                }} />
            </Col>
            <Col lg={6} md={12} sm={24} >
              <Row>Reasons</Row>
              <HeaderSelects
                selectData={{
                  options: dropDownLists?.reasons,
                  value: selectedId?.reason,
                  onChange: (props) => onChangeHandler(props, 'reason', handlers, dispatch),
                  valueLabel: 'name', idLabel: 'id'
                }} />
            </Col>
            <Col lg={6} md={12} sm={24} >
              <Button onClick={() => generateReport(selectedId, dispatch, setLogs)} className='btn-style' type="primary">Generate Report</Button>
            </Col>
          </Row>
        </Card>
        <Row className='borr'>
          <Col className='aligncard' style={{ marginTop: '20px' }} md={18}>
            {logs?.length ?
              <h1 className='f-bold2'>
                Generated At: {logs?.length ? formatDate(new Date(), 'YYYY/MM/DD HH:mm:ss') : ''}
              </h1> :
              ''
            }
          </Col>
          <Col md={6}>
            <Button onClick={printReport} disabled={!logs?.length} className='btn-style3' type="primary">Print Report </Button>
            <Button disabled={!logs?.length} className='btn-style3' type="primary">
              <CSVLink filename={`logs_${(new Date()).toTimeString()}.csv`} data={logs}>
                Export CSV
              </CSVLink>
            </Button>
          </Col>

        </Row>
        <Col id='log-table' className='aligncard' style={{ width: '100%' }}>
          <AuditTrailTable data={logs || []} style={{ width: '100%' }} />
        </Col>
        {/* </Card> */}

      </div>
    </ Spin>
  )

}

export default AuditTrail